import Cookie from "js-cookie"
import _ from "lodash-es"
import { ResponseCode } from "@/utils/axios";
import BusEvent from "@/busEvent";

export default {

    data(){
        return{
            title: '',
            readyScene: false,
            viewMode: '3d',
            sceneData: {},
            measureData: [],
            flyData: []
        }
    },

    beforeDestroy(){
        if( this.viewer ){
            this.viewer.dispose()
            delete window.viewer
        }
    },

    methods: {
        /**
         * 初始化3D场景
         */
        async init( isFree = false, fromBack = false ){
            this.$bus.$emit( BusEvent.ToolDisabledChange, true )
            this.$bus.$emit( BusEvent.MenuDisbaledChange, true )
            if( this.$route.query.id ){
                var url = '/api-application/fullSceneEditor/detail'
                const param = {
                    id: this.$route.query.id,
                    userId: Cookie.get('loginId')
                }
                if( isFree ){
                    url = fromBack ? ( process.env.MODE === 'pro' ? 'https://bec.laozicloud.com/laozi/v3/backcenter/works/unauth/worksPreview' : 'https://bec.laozicloud.net/laozi/v3/backcenter/works/unauth/worksPreview') : '/api-works/laozi/v3/works/unauth/preview'
                    if( fromBack ){
                        delete param.id
                        delete param.userId
                        param.worksId = this.$route.query.id
                    }
                }
                //编辑
                this.axios.post( url, param ).then( (res ) => {
                    if( (res.resp_code == ResponseCode.SUCCESS && !fromBack) || (res.resp_code == 0 && fromBack) ){
                        this.sceneData = res.datas
                        this.title = res.datas.name
                        let modelDatas, cameraData, effectData
                        if( fromBack ){
                            res.datas.modelDatas = res.datas.sceneWorks.modelDatas
                            res.datas.cameraData = res.datas.sceneWorks.cameraData
                            res.datas.effectData = res.datas.sceneWorks.effectData
                        }
                        try {
                            modelDatas = JSON.parse( res.datas.modelDatas )
                            cameraData = res.datas.cameraData && JSON.parse( res.datas.cameraData )
                            effectData = res.datas.effectData && JSON.parse( res.datas.effectData ) || []
                        } catch (error) {
                            this.$message.error('初始化数据失败')
                        }
                        this.$util.createOBS().then(() => {
                            this.initCanvas( modelDatas, cameraData, effectData )
                        })
                        
                    }else{
                        this.$message.warning( res.resp_msg )
                    }
                })
            }else{
            //新建
                this.$util.createOBS().then(() => {
                    this.initCanvas()
                })
            }
        },

        /**
         * 初始化画布
         */
        initCanvas( modelDatas, cameraData, effectData ){
            this.viewer = window.viewer = new AMRT.MapViewer( this.$refs.container, { nv: 1 } )
            if( cameraData && cameraData.destination && cameraData.orientation ){
                this.viewer.flyTo( cameraData )
                this.viewer.gisManager.defaultView = cameraData
            }else{
                this.viewer.flyTo()
            }
            this.viewer.addEventListener( AMRT.Event.MAP_LOADED, () => {
                this.$bus.$emit( BusEvent.ToolDisabledChange, false )
                this.$bus.$emit( BusEvent.MenuDisbaledChange, false )
                this.viewer.mapLoader.loadEnvMap('https://waibu-demo.obs.cn-east-2.myhuaweicloud.com:443/texture/hdr/env.hdr', envMap => {
                    this.viewer.resourceManager.envMap = envMap
                    if( modelDatas ) {
                        //兼容旧数据
                        if( modelDatas.b === undefined ){
                            modelDatas.a = []
                            modelDatas.b = {}
                            delete modelDatas.scenePaths
                            delete modelDatas.modelPaths
                            this.$message.info('版本更新前的老数据暂时无法兼容')
                        }
                        if( modelDatas.a.length > 0 ){
                            const loading = this.$loading({
                                lock: true,
                                text: '场景加载中',
                                background: 'rgba(0, 0, 0, 0.7)'
                            })
                            this.viewer.resourceManager.import( modelDatas, param => {
                                var paths = {}
                                var mTask = [], matTask = []
                                return new Promise((resolve) => {
                                    paths.sky = param.sky
                                    this.$util.getObsFile( param.scene.bucket, param.scene.key ).then(url => {
                                        paths.scene = url
                                        if( paths.m !== undefined && paths.mat !== undefined ){
                                            resolve(paths)
                                        }
                                    })
                                    param.m.map(item => {
                                        mTask.push( this.$util.getObsFile(item.bucket, item.key) )
                                    })
                                    param.mat.map(item => {
                                        matTask.push( this.$util.getObsFile(item.bucket, item.key) )
                                    })
                                    Promise.all(mTask).then(res => {
                                        paths.m = res
                                        if( paths.mat !== undefined && paths.scene !== undefined ){
                                            resolve(paths)
                                        }
                                    })
                                    Promise.all(matTask).then(res => {
                                        paths.mat = res
                                        if( paths.m !== undefined && paths.scene !== undefined ){
                                            resolve(paths)
                                        }
                                    })
                                })
                            }, () => {
                                this.$bus.$emit( BusEvent.SceneChange )
                                loading.close()
                            })
                        }
                    }
                })
                this.tileLoader = new AMRT.TilesLoader( this.viewer )
                this.viewer.gisManager.addEventListener( AMRT.Event.VIEW_CHANGE, _.debounce( this.load3DTile, 1000 ))
                this.loadBoard()
                this.loadHotSpot()
                this.loadMeasureData()
                this.loadFlyData()
                this.initEffect( effectData )
                this.initEvent()
                if( this.$refs.tool ) this.$refs.tool.toggleSelector()
                this.$bus.$emit( BusEvent.MapLoaded ) //地图加载完成
            })
            this.viewer.map.scene.screenSpaceCameraController.maximumZoomDistance =  this.$route.name == 'Editor' ? 20000000 : 26000000
            this.viewer.map.scene.screenSpaceCameraController.minimumZoomDistance = 12
            this.readyScene = true
            this.initNavigation()
        },

        /**
         * 初始化指北针
         */
        initNavigation(){
            var options = {};
            // 用于在使用重置导航重置地图视图时设置默认视图控制。接受的值是Cesium.Cartographic 和 Cesium.Rectangle.
            options.defaultResetView = new Cesium.Cartographic( 1.696620, 0.600938, 16000000 )
            // 用于启用或禁用罗盘。true是启用罗盘，false是禁用罗盘。默认值为true。如果将选项设置为false，则罗盘将不会添加到地图中。
            options.enableCompass = true;
            // 用于启用或禁用缩放控件。true是启用，false是禁用。默认值为true。如果将选项设置为false，则缩放控件将不会添加到地图中。
            options.enableZoomControls = true;
            // 用于启用或禁用距离图例。true是启用，false是禁用。默认值为true。如果将选项设置为false，距离图例将不会添加到地图中。
            options.enableDistanceLegend = true;
            // 用于启用或禁用指南针外环。true是启用，false是禁用。默认值为true。如果将选项设置为false，则该环将可见但无效。
            options.enableCompassOuterRing = true;
            CesiumNavigation.umd( this.viewer.map, options );
        },

        /**
         * 加载标注
         * @author 肖黎望
         * @date 2020-12-23
         * @returns {any}
         */
        loadBoard(){
            var billBoard = window.billBoard = new AMRT.BillBoard( this.viewer, require('@/assets/img/billboard_icon.png') )
            //加载完成后重置一下大小
            billBoard.addEventListener( AMRT.Event.BILLBOARD_LOADED, () => {
                console.log('标注加载完成');
                setTimeout(() => {
                    billBoard.resetSize()
                }, 1000);
            })
            billBoard.clickSelectHandler = object => {
                //如果标注绑定了内容则展示内容
                if( object.userData && object.userData.data && object.userData.data.content ){
                    //PDF和网页
                    if( object.userData.data.eventType == 0 || object.userData.data.eventType == 3 ){
                        if( !object.userData.data.content.startsWith('http') ){
                            object.userData.data.content = 'https://' + object.userData.data.content
                        }
                        window.open( object.userData.data.content )
                    }else{
                    //图片和视频
                        this.$mr_toast({
                            title: object.userData.text,
                            type: object.userData.data.eventType,
                            content: object.userData.data.content
                        })
                    }
                }
            }
            if( this.sceneData.informationCards ){
                try {
                    let informationCards = JSON.parse( this.sceneData.informationCards )
                    billBoard.addEventListener( AMRT.Event.BILLBOARD_INIT, () => {
                        billBoard.import( informationCards )
                    })
                } catch (error) {
                    this.$message.error('标注数据初始化失败')
                }
            }
        },

        /**
         * 加载热点数据
         */
        loadHotSpot(){
            var billBoard2 = window.billBoard2 = new AMRT.BillBoard2( this.viewer, require('@/assets/img/billboard_icon2.png') )
            //加载完成后重置一下大小
            billBoard2.addEventListener( AMRT.Event.HOTSPOT_LOADED, () => {
                console.log('热点加载完成');
                setTimeout(() => {
                    billBoard2.resetSize()
                }, 1000);
            })
            billBoard2.dblclickSelectHandler = object => {
                console.log('选中热点', object);
            } 
            if( this.sceneData.hotspotData ){
                try {
                    let hotspotData = JSON.parse( this.sceneData.hotspotData )
                    billBoard2.addEventListener( AMRT.Event.HOTSPOT_INIT, () => {
                        billBoard2.import( hotspotData )
                    })
                } catch (error) {
                    this.$message.error('标注数据初始化失败')
                }
            }
        },

        /**
         * 加载测量数据
         */
        loadMeasureData(){
            if( this.sceneData.measuredData ){
                try {
                    this.measureData = JSON.parse( this.sceneData.measuredData )
                } catch (error) {
                    this.$message.warning('测量数据初始化失败')
                    this.measureData = []
                }
            }
        },

        /**
         * 加载飞行数据
         */
        loadFlyData(){
            if( this.sceneData.flightData ){
                try {
                    this.flyData = JSON.parse( this.sceneData.flightData )
                } catch (error) {
                    this.$message.warning('测量数据初始化失败')
                    this.flyData = []
                }
            }
        },

        /**
         * 加载3DTile
         * @author 肖黎望
         * @date 2020-12-29
         * @returns {any}   
         */
        load3DTile(){
            var geo = this.viewer.map.camera.computeViewRectangle(this.viewer.map.scene.globe.ellipsoid)
            if( !geo || Math.abs( geo.east - geo.west ) > 0.02 ) return
            geo.west = geo.west / Math.PI * 180
            geo.south = geo.south / Math.PI * 180
            geo.east = geo.east / Math.PI * 180
            geo.north = geo.north / Math.PI * 180
            let location = Number(((geo.west + geo.east) / 2 )).toFixed(6) + ',' + Number((geo.south + geo.north) / 2 ).toFixed(6)
            this.axios.post('/api-application/fullSceneEditor/unauth/regeoSearch', { location }).then((res) => {
                if( res.resp_code == ResponseCode.SUCCESS ){
                    const Result = JSON.parse( res.datas )
                    if( Result.status == '1' && Result.regeocode && Result.regeocode.addressComponent ){
                        var city = Result.regeocode.addressComponent.city
                        if( city.length == 0 ) city = Result.regeocode.addressComponent.province
                        if( city && this.city !== city ){
                            console.log(`加载城市建筑: ${city}`);
                            this.city = city
                            this.axios.post('/api-application/fullSceneEditor/getUrbanBuildingProfile', { city }).then((res) => {
                                if( res.resp_code == ResponseCode.SUCCESS ){
                                    this.tileLoader.load( res.datas + `?time=${Date.now()}` )
                                }
                            })
                        }
                    }
                }
            })
        },

        /**
         * 初始化天气特效
         */
        initEffect( effectData = [] ){
            effectData.map( item => {
                switch ( item.type ) {
                    case "flame":
                        let fire = this.viewer.addFire( item.size )
                        fire.position.fromArray( item.position )
                        this.viewer.gisManager.changeRotationToUp( fire )
                        break;
                    case 'rain':
                        this.viewer.addRain( item.density )
                        break;
                    case 'snow':
                        this.viewer.addSnow( item.density )
                        break;
                    default:
                        break;
                }
            })
        },

        /**
         * 初始化事件
         */
        initEvent(){
            this.viewer.map.camera.changed.addEventListener(_.debounce(() => {
                if( this.viewer.rain ) this.viewer.addRain( this.viewer.rain.density )
                if( this.viewer.snow ) this.viewer.addSnow( this.viewer.snow.density )
            }, 1000))

            this.$bus.$on(BusEvent.CameraChange, () => {
                if( this.viewer.rain ) this.viewer.addRain( this.viewer.rain.density )
                if( this.viewer.snow ) this.viewer.addSnow( this.viewer.rain.density )
                this.viewer.modelGroup.children.map(item => {
                    item.traverse(m => {
                        m.isLargeScene && m.loader.detect()
                    })
                })
            })
        }

    }
}